/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} File_MenuInputs */



/**
* | output |
* | --- |
* | "File menu" |
*
* @param {File_MenuInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const file_menu = /** @type {((inputs?: File_MenuInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<File_MenuInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Menu fichier")
	if (locale === "de") return /** @type {LocalizedString} */ ("Menü „Datei“")
	if (locale === "it") return /** @type {LocalizedString} */ ("Menu File")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Меню «Файл»")
	if (locale === "es") return /** @type {LocalizedString} */ ("Menú de archivo")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("文件菜单")
	if (locale === "ja") return /** @type {LocalizedString} */ ("ファイルメニュー")
	if (locale === "hi") return /** @type {LocalizedString} */ ("फ़ाइल मेनू")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Menu Arquivo")
	return /** @type {LocalizedString} */ ("File menu")
});